// export const serverIp = 'localhost';
export const serverIp = '120.24.189.28';

